import { WebsiteHeaderPhotoSchema_VideoBackground_v1_1_1 } from '@apps/guest/websiteHeader';

export const VIDEO_BACKGROUND_v1_1_1: WebsiteHeaderPhotoSchema_VideoBackground_v1_1_1 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/videoBackground-v1_1_1.json',
  presentationLayout: 'videoBackground',
  desktopVideoUrl: '',
  mobileVideoUrl: '',
  thumbnailImageUrl: undefined,
  eventName: undefined,
  colors: undefined,
};
